import React from 'react';
import { Box, useTheme } from '@mui/material';
import LPMockup_dark from '../../images/LPMockupNew_dark.png';
import LPMockup_light from '../../images/LPMockupNew_light.png';


const StaticHeroImage = () => {
  const theme = useTheme(); // Get the current theme
  const isDarkMode = theme.palette.mode === 'dark'; // Check if the theme is dark

  return (
    <Box
      component="img"
      src={isDarkMode ? LPMockup_dark : LPMockup_light}
      alt="Dashboard Preview"
      sx={{
        width: '100%',
        height: 'auto',
        display: 'block',
      }}
    />
  );
};

export default StaticHeroImage;
